import { http } from '@admin-base/core'

const prefix = '/'
// const filePrefix = '/base/'
const filePrefix = '/'

// 课件列表
const coursewareList = data => {
    return http.post(prefix + 'api/resource/courseware/pageList', data)
}

// 新增课件
const addCourseware = data => {
    return http.post(prefix + 'api/resource/courseware/add', data)
}

// 编辑课件
const editCourseware = data => {
    return http.post(prefix + 'api/resource/courseware/edit', data)
}

// 删除课件
const deleteCourseware = data => {
    return http.post(prefix + `api/resource/courseware/delete/${data}`)
}

// 上/下架课件
const changeStatus = data => {
    return http.post(prefix + 'api/resource/courseware/changeStatus', data)
}

// 课件详情
const coursewareDetail = data => {
    return http.get(prefix + `api/resource/courseware/info/${data}`)
}

// 申请列表
const applyList = data => {
    return http.post(prefix + 'api/resource/courseware/apply/List', data)
}

// 拒绝列表
const rejectList = data => {
    return http.post(prefix + 'api/resource/courseware/reject/List', data)
}

// 审核课件
const coursewareReview = data => {
    return http.post(prefix + 'api/resource/courseware/review', data)
}

// 上传获取课件图片 ppt类型
const getPictures = data => {
    return http.post(filePrefix + 'file/v1/ppt/to/png', data)
}

// 上传获取课件图片 pdf类型
const getPDFPictures = data => {
    return http.post(filePrefix + 'file/v1/pdf2Image', data)
}

// 上传获取课件页数
const getPDFSize = data => {
    return http.post(filePrefix + 'file/v1/pdf/to/png', data)
}

// 合成封面
const compositeCover = data => {
    return http.post(filePrefix + 'file/v1/imageMerge', data)
}

export {
    coursewareList,
    addCourseware,
    editCourseware,
    deleteCourseware,
    changeStatus,
    coursewareDetail,
    applyList,
    rejectList,
    coursewareReview,
    getPictures,
    getPDFPictures,
    getPDFSize,
    compositeCover
}
